import { IFoCaAnTruongSaveRequest } from '../../../api/dich-vu/food/foCaAnTruongApi';
import { fo_caan } from '../../../models/response/dich-vu/food/fo_caan';
import { FoCaAnTruongItemResponse } from '../../../models/response/dich-vu/food/fo_caan_truong';

export enum eFoCaAnTruongActionTypeIds {
	LOAD_START = "FO_CAANTRUONG_LOAD_START",
	LOAD_SUCCESS = "FO_CAANTRUONG_LOAD_SUCCESS",
	LOAD_ERROR = "FO_CAANTRUONG_LOAD_ERROR",

	LOAD_CAAN_START = "FO_CAANTRUONG_LOAD_CAAN_START",
	LOAD_CAAN_SUCCESS = "FO_CAANTRUONG_LOAD_CAAN_SUCCESS",
	LOAD_CAAN_ERROR = "FO_CAANTRUONG_LOAD_CAAN_ERROR",

	SHOW_DETAIL = "FO_CAANTRUONG_SHOW_DETAIL",
	CLOSE_DETAIL = "FO_CAANTRUONG_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "FO_CAANTRUONG_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "FO_CAANTRUONG_SHOW_CONFIRM",
	CLOSE_CONFIRM = "FO_CAANTRUONG_CLOSE_CONFIRM",

	SAVE_START = "FO_CAANTRUONG_SAVE_START",
	SAVE_SUCCESS = "FO_CAANTRUONG_SAVE_SUCCESS",
	SAVE_ERROR = "FO_CAANTRUONG_SAVE_ERROR",

	DELETE_START = "FO_CAANTRUONG_DELETE_START",
	DELETE_SUCCESS = "FO_CAANTRUONG_DELETE_SUCCESS",
	DELETE_ERROR = "FO_CAANTRUONG_DELETE_ERROR"
}

export interface IFoCaAnTruongLoadStart {
	type: eFoCaAnTruongActionTypeIds.LOAD_START,
	payload: number
}
export interface IFoCaAnTruongLoadSuccess {
	type: eFoCaAnTruongActionTypeIds.LOAD_SUCCESS,
	payload: FoCaAnTruongItemResponse[]
}
export interface IFoCaAnTruongLoadErr {
	type: eFoCaAnTruongActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IFoCaAnLoadStart {
	type: eFoCaAnTruongActionTypeIds.LOAD_CAAN_START
}
export interface IFoCaAnLoadSuccess {
	type: eFoCaAnTruongActionTypeIds.LOAD_CAAN_SUCCESS,
	payload: fo_caan[]
}
export interface IFoCaAnLoadErr {
	type: eFoCaAnTruongActionTypeIds.LOAD_CAAN_ERROR,
	payload: string
}
export interface IFoCaAnTruongShowDetail {
	type: eFoCaAnTruongActionTypeIds.SHOW_DETAIL,
	payload?: IFoCaAnTruongSaveRequest
}
export interface IFoCaAnTruongCloseDetail {
	type: eFoCaAnTruongActionTypeIds.CLOSE_DETAIL
}
export interface IFoCaAnTruongChangeSelectedIds {
	type: eFoCaAnTruongActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IFoCaAnTruongShowConfirm {
	type: eFoCaAnTruongActionTypeIds.SHOW_CONFIRM
}
export interface IFoCaAnTruongCloseConfirm {
	type: eFoCaAnTruongActionTypeIds.CLOSE_CONFIRM
}
export interface IFoCaAnTruongSaveStart {
	type: eFoCaAnTruongActionTypeIds.SAVE_START,
	payload: IFoCaAnTruongSaveRequest
}
export interface IFoCaAnTruongSaveSuccess {
	type: eFoCaAnTruongActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IFoCaAnTruongSaveErr {
	type: eFoCaAnTruongActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IFoCaAnTruongDeleteStart {
	type: eFoCaAnTruongActionTypeIds.DELETE_START,
	payload: number[]
}
export interface IFoCaAnTruongDeleteSuccess {
	type: eFoCaAnTruongActionTypeIds.DELETE_SUCCESS
}
export interface IFoCaAnTruongDeleteErr {
	type: eFoCaAnTruongActionTypeIds.DELETE_ERROR,
	payload: string
}

export type IFoCaAnTruongActionTypes = IFoCaAnTruongLoadStart | IFoCaAnTruongLoadSuccess | IFoCaAnTruongLoadErr |
	IFoCaAnLoadStart | IFoCaAnLoadSuccess | IFoCaAnLoadErr |
	IFoCaAnTruongShowDetail | IFoCaAnTruongCloseDetail |
	IFoCaAnTruongChangeSelectedIds |
	IFoCaAnTruongShowConfirm | IFoCaAnTruongCloseConfirm |
	IFoCaAnTruongSaveStart | IFoCaAnTruongSaveSuccess | IFoCaAnTruongSaveErr |
	IFoCaAnTruongDeleteStart | IFoCaAnTruongDeleteSuccess | IFoCaAnTruongDeleteErr
